"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const tslib_1 = require("tslib");
const styled_1 = tslib_1.__importDefault(require("@emotion/styled"));
const react_core_1 = require("@neo-one/react-core");
const React = tslib_1.__importStar(require("react"));
const react_select_1 = tslib_1.__importDefault(require("react-select"));
const styled_tools_1 = require("styled-tools");
const StyledSelect = styled_1.default(react_select_1.default) `
  border: 1px solid rgba(0, 0, 0, 0.3);
  background-color: ${styled_tools_1.prop('theme.gray0')};
  outline: none;

  & > .react-select__control {
    background-color: ${styled_tools_1.prop('theme.gray0')};
    border: 0;
    border-radius: 0;
    box-shadow: none;
    cursor: pointer;

    &:hover {
      border: 0;
      box-shadow: inset 0 0 999em rgba(0, 0, 0, 0.1);
    }

    & > .react-select__indicators {
      & > .react-select__indicator-separator {
        background-color: ${styled_tools_1.prop('theme.black')};
        opacity: 0.2;
      }

      & > .react-select__indicator {
        color: ${styled_tools_1.prop('theme.black')};
      }
    }
  }

  & .react-select__menu {
    background-color: ${styled_tools_1.prop('theme.gray0')};
    width: auto;

    & .react-select__option {
      color: ${styled_tools_1.prop('theme.black')};
      cursor: pointer;
    }

    & .react-select__option.react-select__option--is-selected {
      background-color: ${styled_tools_1.prop('theme.accent')};
      opacity: 0.8;
    }

    & .react-select__option.react-select__option--is-focused {
      background-color: ${styled_tools_1.prop('theme.accent')};
      opacity: 1;
    }
  }
`;
const styles = {
    option: (base, state) => (Object.assign(Object.assign({}, base), { color: react_core_1.theme.black, cursor: 'pointer', width: 'auto', backgroundColor: state.isSelected || state.isFocused ? '#9B98F6' : '#F8F5FD', opacity: state.isSelected ? 0.8 : state.isFocused ? 1 : undefined, fontSize: '0.875rem', lineHeight: '1.46428em', textAlign: 'left', fontFamily: react_core_1.axiforma('Axiforma-Regular'), fontStyle: 'normal', fontWeight: 400 })),
};
function Select(_a) {
    var { 'data-test': dataTest } = _a, props = tslib_1.__rest(_a, ['data-test']);
    return (React.createElement("div", { "data-test": dataTest },
        React.createElement(StyledSelect, Object.assign({ classNamePrefix: "react-select", styles: styles }, props))));
}
exports.Select = Select;

//# sourceMappingURL=Select.js.map
